import { doc, setDoc, increment } from "firebase/firestore";
import { db } from "../firebase";

// Approximate, client-side counters (no server). Good enough to show a vendor
// that their boost drove views/contacts. Fire-and-forget; never blocks the UI.
export function trackView(vendorId) {
  if (!vendorId) return;
  setDoc(doc(db, "stats", vendorId), { views: increment(1) }, { merge: true }).catch(() => {});
}

export function trackClick(vendorId) {
  if (!vendorId) return;
  setDoc(doc(db, "stats", vendorId), { clicks: increment(1) }, { merge: true }).catch(() => {});
}
